<form #form="ngForm" class="form w-100 margin-top-20" (submit)="submitQuestion()">
	<vb-ui-html-editor #htmlEditor name="text" [attr.aria-label]="'Event_QA_AskAQuestion_Text' | translate" [disabled]="processing" [(ngModel)]="questionText" required [editorConfig]="editorConfig" [singleLineMode]="true" [allowEnter]="true" [themedToolbarMode]="true">
	</vb-ui-html-editor>
	<div class="d-flex align-items-center">
		@if (webcast.questionOption !== WebcastQuestionOption.IDENTIFIED) {
			<vb-toggle-button name="postAnonymously" [disabled]="webcast.questionOption === WebcastQuestionOption.ANONYMOUS" [ariaLabel]="'Event_Webcast_PostAnonymously' | translate" [(ngModel)]="isAnonymous">
			</vb-toggle-button>
			<span>{{ 'Event_Webcast_PostAnonymously' | translate }}</span>
		}
		<button type="submit" class="margin-left-auto" vbBtnPrimary [disabled]="form.invalid">
			{{ 'UI_Submit' | translate }}
		</button>
	</div>
</form>
